import { PrimeStatus } from '@osmosis/shared/types/user';

/**
 * Returns true or false. Gets the prime status of the user.
 */
export const hasPrime = (status: PrimeStatus) => status > 0;

/**
 * Returns true or false. Gets the paid prime status of the user.
 */
export const hasOnlyPaidPrime = (status: PrimeStatus) => status === 1;
